"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rollDicePair = rollDicePair;
function rollDicePair() {
    var array = new Uint32Array(2);
    var max = Math.floor((Math.pow(2, 32) - 1) / 6) * 6;
    var getRoll = function (index) {
        var value;
        do {
            crypto.getRandomValues(array);
            value = array[index];
        } while (value >= max);
        return (value % 6) + 1;
    };
    return [getRoll(0), getRoll(1)];
}
//# sourceMappingURL=dice.js.map